import React, { useContext, useEffect } from 'react'
import SoftButton from '../../common/SoftButton'
import SearchButton from './SearchButton'
import { Handbag, Heart, User } from '@phosphor-icons/react'
import { StoreContext } from "@context/StoreContext"
import UserContext from '@context/UserContext'
import UserAccountMenu from './UserAccountMenu'
import { sendGAEvent } from '@utils/analytics'
import { GA_EVENTS } from '@utils/analytics/constants'

const IconMenu = ({ handleSearchBar }) => {
  const { onOpen, isOpen, checkout } = useContext(StoreContext)
  const { isLoggedIn, setOpenLoginModal} = useContext(UserContext)

  useEffect(() => {
	// console.info("bag contents:",checkout)
	const cartItems = checkout?.lines?.edges?.map(item => {
		const { merchandise } = item?.node
		return {
			id: merchandise?.id,
			price: merchandise?.price?.amount,
			currency: merchandise?.price?.currencyCode,
			title: merchandise?.product?.title,
		}
	})
	if(isOpen) sendGAEvent(GA_EVENTS.BAG_VIEW, {queryName: "bag viewed", items: [...cartItems]})
  }, [isOpen])

  return (
    <React.Fragment>
      <div className="relative flex gap-x-6 text-black text-sm mr-2">
        <div className="flex justify-between items-center max-w-[1440px] mx-auto flex-1 gap-x-2 md:gap-x-4">
          <SearchButton onClick={() => {handleSearchBar()}} />
          {isLoggedIn && <SoftButton ariaLabel="Favorite" label={<Heart className='menu-icons' weight="light" />} onClick={() => {}} /> }
          <SoftButton ariaLabel="Cart" label={<Handbag className='menu-icons' weight="light" />} onClick={() => onOpen()} />
          {!isLoggedIn ? (
              <SoftButton ariaLabel="Profile" label={<User className='menu-icons' weight="light" />} onClick={() => setOpenLoginModal(true)} />
            ) : (
              <UserAccountMenu />
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default IconMenu